<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Card {{ block.count }}:</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-block-text
            [type]="'content'"
            [isPlainText]="true"
            [maxLength]="25"
            [blockData]="block.variables?.['Headline'] ?? ''"
            (handleOnChange)="onChange($event, 'Headline')"
            [placeholder]="headlinePlaceholder"
            variable="Headline"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-12 mt-2">
          <app-block-text
            [type]="'link'"
            [isPlainText]="true"
            [maxLength]="4000"
            [blockData]="block.variables?.['Link'] ?? ''"
            (handleOnChange)="onChange($event, 'Link')"
            [placeholder]="linkPlaceholder"
            variable="Link"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-12 mt-3">
          <label>Image or video (required):</label>
          <div class="btn-group format-toggle" role="group" aria-label="Card media type">
            <button type="button" class="btn btn-sm" [class.btn-primary]="format === 'Image'" [class.btn-outline-primary]="format !== 'Image'" (click)="setFormat('Image')">Image</button>
            <button type="button" class="btn btn-sm" [class.btn-primary]="format === 'Video'" [class.btn-outline-primary]="format !== 'Video'" (click)="setFormat('Video')">Video</button>
          </div>
        </div>
        <ng-container *ngIf="format === 'Image'">
          <div class="col-12 mt-2">
            <span class="disclaimer">Ratio 1:1 (min 500x500), 4:5 (min 500x625) or 9:16 (min 500x888).</span><br />
            <span class="disclaimer">Max file size: 30 MB. Formats: JPG, PNG.</span>
            <app-block-text
              [type]="'link'"
              [isPlainText]="true"
              (handleOnChange)="onChange($event, 'Media')"
              [blockData]="block.variables?.['Media'] ?? ''"
              [maxLength]="4000"
              variable="Media"
              [blockId]="block.blockId"
              [isImage]="true"
            ></app-block-text>
          </div>
        </ng-container>
        <ng-container *ngIf="format === 'Video'">
          <div class="col-12 mt-2">
            <span class="disclaimer">Ratio 1:1 (min 500x500), 4:5 (min 500x625) or 9:16 (min 500x888).</span><br />
            <span class="disclaimer">Formats: MP4, MOV or GIF. Max file size: 4 GB. Max length: 240 minutes.</span>
            <app-video-upload (videoSrcEvent)="onChange($event, 'Media')" [videoSrc]="block.variables?.['Media'] ?? ''" [blockId]="block.blockId"></app-video-upload>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</main>
